import * as Yup from "yup";

export const ComponentSchema = Yup.object().shape({
  name: Yup.string()
    .required("Component name is required")
    .matches(
      /^[a-zA-Z0-9_ ]*$/,
      "Name can only contain alphanumeric characters, underscores, and spaces"
    ),
  componentType: Yup.string()
    .required("Component  type is required")
    .matches(
      /^[a-zA-Z0-9_ ]*$/,
      "Name can only contain alphanumeric characters, underscores, and spaces"
    ),
  // permissions: Yup.array()
  //     .of(
  //         Yup.object().shape({
  //         permissionId: Yup.string().required('Permission ID is required'),
  //         permissionName: Yup.string().required('Permission Name is required'),
  //         })
  //     )
  //     .min(1, 'Permissions cannot be an empty array')
  //     .required('Permissions are required'),
  active: Yup.boolean(),
});
